import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/shared/modal';
import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import EstimateWizard from './EstimateWizard';
import styles from './styles.module.scss';

const EstimateGenerator = ({
  email = '',
  phone = '',
  title = '',
  description = '',
  buttonLabel = '',
  displayView = 'instant',
  revenueheroRouterId = null,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleDone = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <div className={styles.estimateGenerator}>
        <div className={styles.hero}>
          {title && (
            <Heading className={styles.title} tag="h2" size="xl">
              {title}
            </Heading>
          )}
          {description && <p className={styles.description}>{description}</p>}
          {displayView === 'button' && (
            <Button theme="accent-primary" onClick={handleOpenModal}>
              {buttonLabel || 'Build an estimate in 1 minute'}
            </Button>
          )}
          {displayView === 'instant' && (
            <EstimateWizard
              email={email}
              phone={phone}
              onDone={handleDone}
              displayView={displayView}
              revenueheroRouterId={revenueheroRouterId}
            />
          )}
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onCloseButtonClick={handleCloseModal}
        onRequestClose={handleCloseModal}
        shouldCloseOnEsc={false}
        style={{
          content: {
            maxWidth: '880px',
          },
        }}
      >
        <EstimateWizard
          email={email}
          phone={phone}
          onDone={handleDone}
          revenueheroRouterId={revenueheroRouterId}
        />
      </Modal>
    </>
  );
};

EstimateGenerator.propTypes = {
  email: PropTypes.string,
  phone: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  displayView: PropTypes.oneOf(['instant', 'button']),
  revenueheroRouterId: PropTypes.number,
};

export default EstimateGenerator;
